module.exports = __webpack_public_path__ + "img/Pool.0661384d.png";